export const calculatePriceDiscount = (previousPrice, price) => {
    const discount = ((previousPrice - price) / previousPrice) * 100;
    return Math.round(discount);
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/utils/calculatePriceDiscount.ts